import { useNavigate } from "react-router";
import { useApi, createAPIPOSTPayload } from "../auth";
import { backend_url } from "../constants";
import Tooltip from "./Tooltip";
import Button from "react-bootstrap/Button";
import NameEdit from "./NameEdit";
import { useState } from "react";

function ResultHeader({ object, exportFunc }) {
  const navigate = useNavigate();
  const { apiFetch } = useApi();
  const [showDelete, setShowDelete] = useState(false);
  function deleteRun() {
    const payload = createAPIPOSTPayload({});
    apiFetch(
      backend_url + "/api/delete-run/" + object.uuid + "/",
      payload,
    ).then((res) => {
      if (res.status == 200) {
        console.log("run-deleted");
        navigate("/");
      } else {
        res.json().then((json) => console.log(json));
      }
    });
  }
  return (
    <div className="result-header">
      <div
        className="result-header-arrow"
        onClick={(e) => {
          e.preventDefault();
          navigate("/");
        }}
      >
        <span class="material-symbols-rounded">chevron_left</span>
      </div>
      <b style={{ padding: "15px" }}>Prediction Results</b>
      <Tooltip>
        <div>
          <span
            style={{
              fontVariationSettings:
                "'FILL' 1, 'wght' 300, 'GRAD' 0, 'opsz' 24",
            }}
            className="material-symbols-rounded"
          >
            science
          </span>
          {object.smiles}
        </div>
      </Tooltip>
      <div style={{marginLeft: "10px"}}>
        <Tooltip>
          <div>
            <span
              style={{
                fontVariationSettings:
                  "'FILL' 1, 'wght' 300, 'GRAD' 0, 'opsz' 24",
              }}
              className="material-symbols-rounded"
            >
              memory
            </span>
            {object.model_version}
          </div>
        </Tooltip>
      </div>
      <NameEdit initialName={object.name} uuid={object.uuid} />
      <div className="result-header-buttons">
        <Button variant="light" onClick={() => setShowDelete(true)}>
          <span class="material-symbols-rounded">delete</span> Delete
        </Button>
        <Button variant="light">
          <span class="material-symbols-rounded">share</span> Share
        </Button>
        <Button variant="light" onClick={exportFunc}>
          <span class="material-symbols-rounded">download</span> Export
        </Button>
      </div>
      {showDelete ? (
        <div className="delete-modal">
          <div className="delete-modal-header">
            <h3>Are you sure you want to delete this run?</h3>
            <div style={{ marginLeft: "2rem" }}>
              <span
                style={{
                  cursor: "pointer",
                  fontVariationSettings:
                    "'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 36",
                }}
                className="material-symbols-rounded"
                onClick={() => setShowDelete(false)}
              >
                close
              </span>
            </div>
          </div>
          <div className="delete-modal-body">
            <Button
              variant="danger"
              onClick={(e) => {
                e.preventDefault();
                deleteRun();
                setShowDelete(false);
              }}
            >
              Yes, Delete
            </Button>
            <Button variant="light" onClick={() => setShowDelete(false)}>
              No, Cancel
            </Button>
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default ResultHeader;
